import { render, staticRenderFns } from "./GeneralDataTab.vue?vue&type=template&id=66e28060&scoped=true"
import script from "./GeneralDataTab.vue?vue&type=script&lang=js"
export * from "./GeneralDataTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataTab.vue?vue&type=style&index=0&id=66e28060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e28060",
  null
  
)

export default component.exports